import React from 'react';

import { Chip } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IBaseItem, ICartEntry } from '@rbi-ctg/menu';
import { primitive } from 'styles/constants/primitives';

import { UpsellModalAddToCart } from './upsell-modal-add-to-cart';
import { UpsellModalItem } from './upsell-modal-item';
import { UpsellModalQuantityChange } from './upsell-modal-quantity-change';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px;
  overflow-y: auto;
  height: 72vh;
`;

const StyledChip = styled(Chip)`
  position: absolute;
  inset-block-start: 8px;
  inset-inline-start: 8px;

  height: 24px;
  padding-inline: 8px;

  color: ${primitive.$success};
  background: ${primitive.$successBg};

  & > div {
    background-color: ${primitive.$success};
    border-radius: 50%;
  }
`;

interface UpsellModalContentProps {
  upsellItems: IBaseItem[];
  cartEntries: ICartEntry[];
  onAddItem: (item: IBaseItem) => void;
}

export const UpsellModalContent: React.FC<UpsellModalContentProps> = ({
  cartEntries,
  upsellItems,
  onAddItem,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Container>
      {upsellItems.map(item => {
        const cartItem = cartEntries.find(c => c._id === item._id);

        return (
          <UpsellModalItem
            item={item}
            key={item._id}
            chipComponent={
              cartItem && (
                <StyledChip icon="check" aria-label="Upsell item added">
                  {formatMessage({ id: 'addedChip' })}
                </StyledChip>
              )
            }
            actions={
              cartItem ? (
                <UpsellModalQuantityChange item={cartItem} />
              ) : (
                <UpsellModalAddToCart onClick={() => onAddItem(item)} />
              )
            }
          />
        );
      })}
    </Container>
  );
};
